export default __webpack_public_path__ + "static/media/Graph_SMP-RiskSpectrum.434a399b.svg";